import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ExternalPaymentsSvc from '../api/configPaymentButton.service';
import { UseManualPaymentButton, ConfigPaymentButton } from '../types';

const useManualPaymentButton = (): UseManualPaymentButton => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const orderReference: string | null = searchParams.get('p');

  useEffect(() => {
    const initEfexPayButton = async () => {
      setLoading(true);

      try {
        if (orderReference) {
          const configPaymentButton: ConfigPaymentButton =
            await ExternalPaymentsSvc.getConfigPaymentButton(orderReference);
          const { EfexPayButton } = (window as unknown as any)?.efexpay || {};
          const efexPayButtonInstance = new EfexPayButton(configPaymentButton);
          await efexPayButtonInstance.init();
          efexPayButtonInstance.showModal();
          setError(false);
        }
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (orderReference) {
      initEfexPayButton();
    }
  }, [orderReference]);

  return {
    loading,
    error,
  };
};

export default useManualPaymentButton;
